import React, { createContext, useContext, useState } from 'react';
import httpClient from '../http/client';

const TENANT_API_URL = process.env.REACT_APP_TENANT_API_URL;

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [tenantData, setTenantData] = useState(null);
  const [error, setError] = useState(false);

  const handleTenantData = async (tenantId, setTenant = true) => {
    try {
      const response = await httpClient.get(`${TENANT_API_URL}/${tenantId}`);
      const data = response.data;

      if (setTenant) setTenantData(data);
      localStorage.setItem('tenantDomain', data?.profile?.base_url ?? '');
      setLoading(false);
      setError(false);
      return data;
    } catch (err) {
      console.error(err);
      setError(true);
      setLoading(false);
      return false;
    }
  };

  return (
    <TenantContext.Provider
      value={{ setTenantData, tenantData, handleTenantData, loading, error }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);
